import {api as axios} from '../../shared/axios';
import useSWR from "swr";
import { API_URL } from "../../shared/config";

const fetcher = (url) => axios.get(url);

export const useGetDevice = (id,physical_type) => {
    const { data, error } = useSWR(`${API_URL}/plant/${id}/device/?physical_type=${physical_type}`, fetcher)
    return {
      deviceList: data?.data,
      isLoadingDeviceList: !error && !data?.data,
      isErrorDeviceList: error
    }
}

export const useGetHuaweiDeviceList = (id) => {
    const { data, error } = useSWR(`${API_URL}/plant/${id}/device/huawei/`, fetcher)

    const huaweiDeviceList = data?.data?.map((device)=>({
        label: device?.devName, // value and label is used in the select input
        value: device?.devTypeId,
        deviceTypeId: device?.devTypeId,
        id: `${device?.id}`,
    }));
    return {
      huaweiDeviceList: huaweiDeviceList,
      isLoadingHuaweiDeviceList: !error && !huaweiDeviceList,
      isErrorHuaweiDeviceList: error
    }
}

export const useGetHuaweiDeviceGroup = (id) => {
    const { data, error } = useSWR(`${API_URL}/plant/${id}/device/huawei/?group=true`, fetcher)

    return {
      huaweiDeviceList: data,
      isLoadingHuaweiDeviceList: !error && !data,
      isErrorHuaweiDeviceList: error
    }
}


export const addDevice = async ({details, type='other'}) => {
    const url = type==='huawei-cloud'?`${API_URL}/thirdparty/huawei/device/add/`:`${API_URL}/device/`;
    try {
        const request = await axios.post(url, details);
        return { data: request.data, error: undefined, success: true };

    } catch (error) {
        return { data: undefined, error: error.response.data.error ,success: false };
        
  }
}

export const editDevice = async ({deviceId,details,type}) => {
    try {
        const request = await axios.patch(`${API_URL}/device/${deviceId}/`,details);
        return { data: request.data, error: undefined, success: true };
    } catch (error) {
        return { data: undefined, error: error.response.data.error, success: false };
    }
}